// DashboardLayout.styles.js
import { createStyles } from '@mantine/core';

export default createStyles((theme) => ({
  container: {
    display: 'flex',
    minHeight: '100vh',
    width:'100%',
  },

  sidebar: {
    position: 'fixed', // Fixes the sidebar to the viewport
    top: 0,
    left: 0,
    height: '100vh',   // Full viewport height
    transition: 'width 0.3s ease',
    overflow: 'hidden',
    backgroundColor: '#fff',
    borderRight: '1px solid #ddd',
    boxShadow: '3px 0 6px -6px rgba(0,0,0,0.8)',
  },
  

  sidebarHeader: {
    display: 'flex',
    alignItems: 'center',
    height: 70,
    gap: theme.spacing.sm,          
    backgroundColor: '#2a9ca6',
    paddingLeft: '5px',
    color:'white',
    
  },

  header: {
    height: 70,
    borderBottom: `0px solid #ddd`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 1rem',
    backgroundColor: '#2a9ca6',
    position: 'fixed',
    top: 0,
    zIndex: 1000,
    transition: 'left 0.3s ease',
    // left :'220px !important',

    //    // Media queries for header
    //    '@media (max-width: 1600px)': {
    //     left: '200px !important',
    //   },
    //   '@media (max-width: 1361px)': {
    //     left: '180px !important',
    //   },
    //   '@media (max-width: 1024px)': {
    //     left: '150px !important',
    //   },
    //   '@media (max-width: 768px)': {
    //     left: '100px !important',
    //   },
    //   '@media (max-width: 556px)': {
    //     left: '0px !important',
    //   },
   
  },



  content: {
    marginTop: 70, // offset for fixed header
    transition: 'margin-left 0.3s ease',
    padding: '1rem',
    backgroundColor :'#fbfbfb',
    overflow: 'hidden',
    width:'100%'
   
  },

  scrollArea: {
    height: '100%',
    backgroundColor: '#ffffff',
    
  },
}));
